import createArrayFacet from '../createArrayFacet';

export default createArrayFacet({
  stateKey: 'distributionInCountries',
  itemKey: 'distributionInCountries',
  configKey: 'filterHasDistribution',
});
